import { Trans, useTranslation } from 'react-i18next'
import { formatNorwegianDate } from '../../../utils/dateUtils'

interface Props {
  from: string
  to: string
  // 3-state: undefined = alle, false = personbil only, true = varebil only.
  varebil: boolean | undefined
  klasse: string[]
}

/**
 * Blue info box above the Oversikt tables — spells out exactly which query
 * produced them so the user can trust the numbers. Styled after the
 * Nybilstatistikk QueryExplanationBox. The Oversikt tab runs on the global
 * filters only (period, vehicle type, klasse); no merke or år-range applies.
 */
export default function OversiktExplanation({ from, to, varebil, klasse }: Props) {
  const { t } = useTranslation('bruktbil')
  const b = { b: <strong /> }
  return (
    <div
      data-testid="oversikt-explanation"
      className="card p-4 bg-blue-50 dark:bg-blue-900/10 border border-blue-200 dark:border-blue-800"
    >
      <p className="text-sm text-blue-800 dark:text-blue-300 leading-relaxed">
        <Trans
          t={t}
          i18nKey="merkeModell.oversiktExplanation.periode"
          values={{ from: formatNorwegianDate(from), to: formatNorwegianDate(to) }}
          components={b}
        />{' '}
        {varebil === undefined ? (
          <Trans t={t} i18nKey="merkeModell.oversiktExplanation.alleKjoretoy" components={b} />
        ) : varebil ? (
          <Trans t={t} i18nKey="merkeModell.oversiktExplanation.kunVarebil" components={b} />
        ) : (
          <Trans t={t} i18nKey="merkeModell.oversiktExplanation.kunPersonbil" components={b} />
        )}{' '}
        {klasse.length === 0 ? (
          t('merkeModell.oversiktExplanation.alleKlasser')
        ) : (
          <Trans
            t={t}
            i18nKey="merkeModell.oversiktExplanation.filtrertKlasser"
            values={{ n: klasse.length }}
            components={b}
          />
        )}{' '}
        <Trans t={t} i18nKey="merkeModell.oversiktExplanation.tabellene" components={b} />
      </p>
    </div>
  )
}
